import linkedinIcon from 'assets/icons/social-media/linkedin.svg'
import twitterIcon from 'assets/icons/social-media/twitter.svg'
import facebookIcon from 'assets/icons/social-media/facebook.svg'
import instagramIcon from 'assets/icons/social-media/instagram.svg'

type SocialMediaType = {
    url: string
    alt: string
    href: string
}

export const SocialMedia: Array<SocialMediaType> = [
    {
        url: linkedinIcon,
        alt: 'LinkedIn',
        href: 'https://www.linkedin.com/company/genomate-health/'
    },
    {
        url: twitterIcon,
        alt: 'Twitter',
        href: 'https://twitter.com/GenomateHealth'
    },
    {
        url: facebookIcon,
        alt: 'Facebook',
        href: 'https://www.facebook.com/genomate.health'
    },
    {
        url: instagramIcon,
        alt: 'Instagram',
        href: 'https://www.instagram.com/genomate.health/'
    }
]
